import { Star } from 'lucide-react';

const labelClass = 'block text-sm font-medium text-[#00163E] mb-1.5';
const errorClass = 'text-red-500 text-xs mt-1';

const NIVELES = [
  { id: 'R1', title: 'R1', subtitle: 'Senior Advisor', desc: '10+ años de experiencia. Roles de responsabilidad directiva.', stars: 1 },
  { id: 'R2', title: 'R2', subtitle: 'Executive Advisor', desc: '20+ años. Dirección general o C-Level contrastado.', stars: 2 },
  { id: 'R3', title: 'R3', subtitle: 'Principal Advisor', desc: 'Trayectoria excepcional. Liderazgo empresarial de referencia.', stars: 3 },
];

const DISPONIBILIDAD = ['< 5 horas', '5–10 horas', 'Más de 10 horas'];
const MODALIDADES = ['Remoto', 'Presencial', 'Híbrido'];

const PROVINCIAS = [
  'Álava', 'Albacete', 'Alicante', 'Almería', 'Asturias', 'Ávila', 'Badajoz',
  'Barcelona', 'Burgos', 'Cáceres', 'Cádiz', 'Cantabria', 'Castellón', 'Ciudad Real',
  'Córdoba', 'A Coruña', 'Cuenca', 'Girona', 'Granada', 'Guadalajara', 'Gipuzkoa',
  'Huelva', 'Huesca', 'Illes Balears', 'Jaén', 'León', 'Lleida', 'Lugo',
  'Madrid', 'Málaga', 'Murcia', 'Navarra', 'Ourense', 'Palencia', 'Las Palmas',
  'Pontevedra', 'La Rioja', 'Salamanca', 'Santa Cruz de Tenerife', 'Segovia',
  'Sevilla', 'Soria', 'Tarragona', 'Teruel', 'Toledo', 'Valencia', 'Valladolid',
  'Bizkaia', 'Zamora', 'Zaragoza', 'Ceuta', 'Melilla',
];

const IDIOMAS = ['Español', 'Inglés', 'Francés', 'Alemán', 'Italiano', 'Portugués', 'Otros'];

export default function StepNivel({ data, errors, onChange }) {
  const toggleArray = (field, value) => {
    const current = data[field] || [];
    const next = current.includes(value)
      ? current.filter((v) => v !== value)
      : [...current, value];
    onChange(field, next);
  };

  const handleTodaEspana = () => {
    const allSelected = (data.zonaPresencial || []).length === PROVINCIAS.length;
    onChange('zonaPresencial', allSelected ? [] : [...PROVINCIAS]);
  };

  const allProvincesSelected = (data.zonaPresencial || []).length === PROVINCIAS.length;

  return (
    <div className="space-y-6">
      <p className="text-[#8A9BB1] text-sm mb-1">
        Conadvy clasifica a sus advisors en tres niveles de seniority.
        Seleccione el que mejor refleje su trayectoria.
      </p>

      {/* Nivel */}
      <div>
        <label className={labelClass}>Nivel estimado</label>
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mt-1 items-stretch">
          {NIVELES.map((n) => {
            const selected = data.nivel === n.id;
            return (
              <button
                key={n.id}
                type="button"
                onClick={() => onChange('nivel', n.id)}
                data-testid={`adv-nivel-${n.id}`}
                className={`p-6 rounded border text-left transition-all duration-200 relative overflow-hidden h-full flex flex-col ${
                  selected ? 'border-[#C58C40] bg-[#00163E]/[0.03] shadow-sm' : 'border-[#E4E6EA] hover:border-[#00163E]/30'
                }`}
              >
                <div className="flex items-center gap-1 h-4 mb-3">
                  {Array.from({ length: n.stars }).map((_, i) => (
                    <Star key={i} size={14} className={selected ? 'text-[#C58C40] fill-[#C58C40]' : 'text-[#00163E]/20'} />
                  ))}
                </div>
                <h4 className={`text-xl font-medium mb-0.5 ${selected ? 'text-[#C58C40]' : 'text-[#00163E]'}`}>{n.title}</h4>
                <p className={`text-xs font-medium tracking-wide mb-3 ${selected ? 'text-[#C58C40]/70' : 'text-[#00163E]/40'}`}>{n.subtitle}</p>
                <p className="text-[#8A9BB1] text-xs leading-relaxed">{n.desc}</p>
              </button>
            );
          })}
        </div>
        {errors.nivel && <p className={errorClass}>{errors.nivel}</p>}
      </div>

      {/* Disponibilidad */}
      <div>
        <label className={labelClass}>Disponibilidad mensual estimada</label>
        <div className="flex rounded border border-[#E4E6EA] overflow-hidden mt-1">
          {DISPONIBILIDAD.map((d) => {
            const selected = data.disponibilidad === d;
            return (
              <button
                key={d}
                type="button"
                onClick={() => onChange('disponibilidad', d)}
                data-testid={`adv-disp-${d.replace(/\s+/g, '-').toLowerCase()}`}
                className={`flex-1 py-3 text-xs sm:text-sm font-medium transition-all duration-200 ${
                  selected ? 'bg-[#00163E] text-white' : 'bg-white text-[#00163E]/60 hover:bg-[#00163E]/5'
                }`}
              >
                {d}
              </button>
            );
          })}
        </div>
        {errors.disponibilidad && <p className={errorClass}>{errors.disponibilidad}</p>}
      </div>

      {/* Modalidad */}
      <div>
        <label className={labelClass}>Modalidad</label>
        <div className="flex rounded border border-[#E4E6EA] overflow-hidden mt-1">
          {MODALIDADES.map((m) => {
            const val = m.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
            const selected = data.modalidad === val;
            return (
              <button
                key={m}
                type="button"
                onClick={() => onChange('modalidad', val)}
                data-testid={`adv-mod-${val}`}
                className={`flex-1 py-3 text-sm font-medium transition-all duration-200 ${
                  selected ? 'bg-[#00163E] text-white' : 'bg-white text-[#00163E]/60 hover:bg-[#00163E]/5'
                }`}
              >
                {m}
              </button>
            );
          })}
        </div>
        {errors.modalidad && <p className={errorClass}>{errors.modalidad}</p>}
      </div>

      {/* Zona presencial — solo si Presencial o Híbrido */}
      {(data.modalidad === 'presencial' || data.modalidad === 'hibrido') && (
        <div className="animate-in fade-in slide-in-from-top-2 duration-300">
          <label className={labelClass}>Provincias donde puede acudir</label>
          <p className="text-[#8A9BB1] text-xs mb-3">Seleccione todas las provincias donde estaría disponible</p>

          {/* Toda España toggle */}
          <button
            type="button"
            onClick={handleTodaEspana}
            data-testid="adv-zona-toda-espana"
            className={`mb-3 px-4 py-2 text-xs rounded border transition-all duration-200 ${
              allProvincesSelected
                ? 'border-[#C58C40] bg-[#C58C40]/10 text-[#C58C40] font-medium'
                : 'border-[#E4E6EA] text-[#00163E]/60 hover:border-[#00163E]/30'
            }`}
          >
            Toda España {allProvincesSelected ? '(seleccionado)' : ''}
          </button>

          <div className="flex flex-wrap gap-1.5 max-h-48 overflow-y-auto pr-1">
            {PROVINCIAS.map((p) => {
              const selected = (data.zonaPresencial || []).includes(p);
              return (
                <button
                  key={p}
                  type="button"
                  onClick={() => toggleArray('zonaPresencial', p)}
                  data-testid={`adv-zona-${p.replace(/\s+/g, '-').toLowerCase()}`}
                  className={`px-2.5 py-1 text-xs rounded border transition-all duration-200 ${
                    selected
                      ? 'border-[#C58C40] bg-[#C58C40]/10 text-[#C58C40]'
                      : 'border-[#E4E6EA] text-[#00163E]/50 hover:border-[#00163E]/30'
                  }`}
                >
                  {p}
                </button>
              );
            })}
          </div>
          {errors.zonaPresencial && <p className={errorClass}>{errors.zonaPresencial}</p>}
        </div>
      )}

      {/* Idiomas */}
      <div>
        <label className={labelClass}>Idiomas</label>
        <p className="text-[#8A9BB1] text-xs mb-3">Seleccione los idiomas en los que puede trabajar</p>
        <div className="flex flex-wrap gap-2">
          {IDIOMAS.map((lang) => {
            const selected = (data.idiomas || []).includes(lang);
            return (
              <button
                key={lang}
                type="button"
                onClick={() => toggleArray('idiomas', lang)}
                data-testid={`adv-idioma-${lang.toLowerCase()}`}
                className={`px-4 py-2 text-sm rounded border transition-all duration-200 ${
                  selected
                    ? 'border-[#C58C40] bg-[#C58C40]/10 text-[#C58C40]'
                    : 'border-[#E4E6EA] text-[#00163E]/60 hover:border-[#00163E]/30'
                }`}
              >
                {lang}
              </button>
            );
          })}
        </div>
        {errors.idiomas && <p className={errorClass}>{errors.idiomas}</p>}
      </div>
    </div>
  );
}
